import React, { useEffect, useState } from "react";
import "./style.scss";
import { getAlphabets, romanize } from "../../../utils/commonFunctions";
import { CollapseClose, CollapseOpen } from "../../../assets/images";
import { FirstLevelType, ProceduresType, ProcedureType, SecondLevelType, SubHeadingType } from "../../../commonTypes/jobsType";
import { checkIsValid } from "./commonFunction";

type AppProps = {
  data: ProceduresType;
  title: string;
  fileData: string;
};

const JobPreview = ({ data, title, fileData }: AppProps) => {
  const [isGuideline, setIsGuideline] = useState(true);

 

  useEffect(() => {
    if (
      checkIsValid(fileData)
    ) {
      let contentDiv: any = document.getElementById("guidelines");
      contentDiv.innerHTML = fileData;
    }
  }, [fileData]);

  const handleChangeGuidline = () => {
    setIsGuideline((prev: boolean) => !prev);
    if (!isGuideline) {
      let contentDiv: any = document.getElementById("guidelines");
      contentDiv.innerHTML = fileData;
    }
  };

  return (
    <div style={{ width: "30%", wordWrap: "break-word" }}>
      <div>
        {checkIsValid(fileData) ? (
          <div className="guideline-preview">
            <div className="d-flex align-items-center ">
              <div className="pointer" onClick={() => handleChangeGuidline()}>
                <img
                  src={isGuideline ? CollapseOpen : CollapseClose}
                  alt="expand/collapse"
                />
              </div>
              <p>Document Guideline</p>
            </div>

            <div
              className="pl-4"
              style={{
                overflow: "auto",
                display: !isGuideline ? "none" : "block",
              }}
              id="guidelines"
            ></div>
          </div>
        ) : null}

        {data?.map((procedure: ProcedureType, index: number) => {
          let count=0
          if(!procedure?.is_deleted){
            return (
              <div key={index}>
                {procedure?.value ? (
                  <div key={index} className="pl-4 procedure">
                    {" "}
                    {procedure?.value}
                  </div>
                ) : null}
  
                {procedure?.value ? <div className="line"></div> : null}
                <div className="pl-2">
                  {procedure?.subHeading?.map(
                    (subHeading: SubHeadingType, subIndex: number) => {
                      let newCount=0;
                      if(!subHeading?.is_deleted){
                        return (
                          <div key={index?.toString()+subIndex?.toString()}>
                            {subHeading?.value ? (
                              <div className="text">
                                <div className="numbering">{++count}</div>{" "}
                                <span>{subHeading?.value}</span>
                              </div>
                            ) : null}
    
                            <div className="pl-4">
                              {subHeading?.firstLevel?.map(
                                (
                                  firstLevel: FirstLevelType,
                                  firstIndex: number
                                ) => {
                                  let secondCount=0;
                                  if(!firstLevel?.is_deleted){
                                    return (
                                      <div key={index?.toString() + subIndex?.toString() + firstIndex?.toString()}>
                                        {firstLevel?.value ? (
                                          <div className="text">
                                            <span className="numbering">
                                              {getAlphabets(
                                                ++newCount
                                              )?.toUpperCase()}
                                            </span>{" "}
                                            <span>{firstLevel?.value}</span>
                                          </div>
                                        ) : null}
                                        <div className="pl-4">
                                          {firstLevel?.secondLevel?.map(
                                            (
                                              secondLevel: SecondLevelType,
                                              secondIndex: number
                                            ) => {
                                              if(!secondLevel?.is_deleted){
                                                
                                                return (
                                                  <div key={index?.toString() + subIndex?.toString() + firstIndex?.toString() + secondIndex?.toString()}>
                                                    {secondLevel?.value ? (
                                                      <div className="text">
                                                        <div className="numbering">
                                                          {romanize(++secondCount)}
                                                        </div>{" "}
                                                        <span>
                                                          {secondLevel?.value}
                                                        </span>
                                                      </div>
                                                    ) : null}
                                                  </div>
                                                );
                                              }
                                              
                                            }
                                          )}
                                        </div>
                                      </div>
                                    );
                                  }
                                 
                                }
                              )}
                            </div>
                          </div>
                        );
                      }
                      
                    }
                  )}
                </div>
              </div>
            );
          }
         
        })}
      </div>
    </div>
  );
};

export default JobPreview;
